import { IconWrapper } from '../runtime';
export default IconWrapper('phone-one', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("rect", {
    "attrs": {
      "x": "5",
      "y": "5",
      "width": "38",
      "height": "38",
      "rx": "3",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("rect", {
    "attrs": {
      "x": "11",
      "y": "12",
      "width": "8",
      "height": "24",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("rect", {
    "attrs": {
      "x": "25",
      "y": "12",
      "width": "12",
      "height": "6",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("circle", {
    "attrs": {
      "cx": "25",
      "cy": "24",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "25",
      "cy": "30",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "25",
      "cy": "36",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "31",
      "cy": "24",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "31",
      "cy": "30",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "31",
      "cy": "36",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "37",
      "cy": "24",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "37",
      "cy": "30",
      "r": "2",
      "fill": props.colors[0]
    }
  }), h("circle", {
    "attrs": {
      "cx": "37",
      "cy": "36",
      "r": "2",
      "fill": props.colors[0]
    }
  })]);
});